import { Services } from "@/types/serviceTypes";
import { VariantServices } from "@/types/types";
import { MANDATORY_SERVICES } from "@/constants/constants.ts";
import { BundleServices } from "@/utils/product/getBundleServices.ts";

type Options = {
  mandatoryServicesOverride: string[];
};

export const mappedServices = (
  services: VariantServices | BundleServices,
  options: Options = { mandatoryServicesOverride: [] },
): Services => {
  if (!services) return [];

  const mandatoryServices = [
    ...MANDATORY_SERVICES,
    ...(options?.mandatoryServicesOverride || []),
  ];

  const addBlankLinkTargets = (html: string): string => {
    if (!html) return html ?? "";
    return html.replace(/<a\s([^>]*)>/gi, (match, attrs: string) => {
      const hasHref = /\bhref\s*=/i.test(attrs);
      const hasTarget = /\btarget\s*=/i.test(attrs);
      if (hasHref && !hasTarget) {
        return `<a ${attrs} target="_blank">`;
      }
      return match;
    });
  };

  return services
    .filter(
      (service) =>
        service.__typename === "DeliveryService" ||
        service.__typename === "ExtendedWarranty",
    )
    .map((service) => {
      const { __typename, title, id } = service;

      if (__typename === "ExtendedWarranty") {
        if (!service.aliases || !service.price) return null;
        const {
          confirmation,
          policyDetail,
          purchaseDescription,
          tooltip,
          aliases: { skuId },
          price: { display, value },
          duration,
        } = service;

        return {
          id,
          title,
          display,
          duration,
          value: parseFloat(value),
          selected: false,
          skuId: skuId,
          tooltip: addBlankLinkTargets(tooltip),
          purchaseDescription,
          policyDetail: addBlankLinkTargets(policyDetail),
          confirmation: addBlankLinkTargets(confirmation),
          serviceType: "ExtendedWarranty",
          isMandatory: false,
        };
      }

      const {
        description,
        price: { display, value },
        aliases: { dmsId },
      } = service;

      return {
        id,
        title,
        description,
        display,
        value: parseFloat(value),
        selected: false,
        skuId: `DMS${dmsId}`,
        serviceType: "DeliveryService",
        isMandatory: mandatoryServices.includes(dmsId),
      };
    })
    .filter((s): s is Services[number] => s !== null);
};
